export default function encodeQueryData(data) {
    const ret = [];
    for (let d in data)
      ret.push(d + '=' + data[d]);
    return ret.join('&');
 }